import React, { lazy, Suspense } from 'react'
import LoadingComponent from 'components/generic/LoadingComponent'

const LazyComponent = lazy(() => import(/* webpackChunkName: "facebookComments" */ './'))

export default function CourseCommentsLazy(props) {
  return (
    <Suspense fallback={<LoadingComponent />}>
      <LazyComponent {...props} />
    </Suspense>
  )
}
